import {BaseUtils} from "./base-utils";
import {LocalStorageUtils} from "./local-storage.utils";

export class AbTestingUtils extends BaseUtils {
  static injectables = [...BaseUtils.injectables, LocalStorageUtils];

  constructor(localStorageUtils: LocalStorageUtils) {
    super();

    this.localStorageUtils = localStorageUtils;
  }

  setABTestingValue(storageKey, ratio, values) {
    let value = this.localStorageUtils.get(storageKey);

    if(value === undefined) {
      value = this.getABTestingValue(ratio, values);
      this.localStorageUtils.set(storageKey, value);
    }

    return value;
  }

  getABTestingValue(ratio, values) {
    const groupRatioA: Number = ratio;
    const groupRatioB: Number = 1 - ratio;

    let options = [];
    Object.values(values).forEach(mode => options.push(mode));

    const valueByABTesting = this.getABTestingOption(groupRatioA, groupRatioB);

    return options.includes(valueByABTesting) ? valueByABTesting : options[valueByABTesting];
  }

  getABTestingOption(optionA: Number = 0.5, optionB: Number = 0.5, ...options) {
    const optionsArray: Array<Number> = [optionA, optionB, ...options];
    const random: Number = Math.random();
    let sum: Number = 0;

    const index: Number = optionsArray.findIndex((option: Number) => {
      sum += option;

      return random < sum;
    })

    return index;
  }
}
